import { render, staticRenderFns } from "./LTable.vue?vue&type=template&id=6812bac1&"
import script from "./LTable.vue?vue&type=script&lang=js&"
export * from "./LTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports